export const AUI_VERSION = '2.9.7';
export const AUI_LAST_UPDATE = '2019-12-04T00:10:50.574Z';
